import { ChangeDetectorRef, Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe';
import { DocumentsActions } from '@modeso/aumico-lib-annualreport-fe/actions/workflow-documents.actions';
import { CPTask, InventoryData, MMTask } from '@modeso/aumico-lib-annualreport-fe/dtos/inventory-data.dto';
import { ITasksExportTableHeaders } from '@modeso/aumico-lib-annualreport-fe/dtos/tasks-export-table-headers.dto';
import { WorkflowDocumentsProvider } from '@modeso/aumico-lib-annualreport-fe/provider/workflow-documets.provider';
import {
    DocumentDto,
    ExportTasksExcelData,
    selectMandateManagementWorkflow,
    TaskState,
    WorkflowsActions,
    WorkflowsState,
} from '@modeso/aumico-lib-cpmm-fe';
import { FilePreviewStatus } from '@modeso/aumico-lib-cpmm-fe/enums/FilePreviewStatus.enum';
import { ProjectsOverviewActions } from '@modeso/aumico-lib-projects-fe/src/lib/actions/projects-overview.actions';
import {
    selectActiveProject,
    selectActiveProjectId,
} from '@modeso/aumico-lib-projects-fe/src/lib/reducers/projects-overview.reducer';
import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { I18NextService } from 'angular-i18next';
import { cloneDeep } from 'lodash-es';
import { Moment } from 'moment';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs';
import { filter, first, map, switchMap, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { SyncActions } from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/sync.actions';
import { TasksOverviewActions } from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/tasks.actions';
import { setScrollToTextState } from '@modeso/aumico-lib-cpmm-fe/actions/ui.actions';
import { CreateAnnotationDto } from '../../../../../../aumico-lib-cpmm-fe/src/lib/dtos/create-annotation-dto.interface';
import { CreateTaskRequestDto } from '../../../../../../aumico-lib-cpmm-fe/src/lib/dtos/create-task-dto.interface';
import { UpdateAnnotationDto } from '../../../../../../aumico-lib-cpmm-fe/src/lib/dtos/update-annotation-dto.interface';
import { UpdateTaskDto } from '../../../../../../aumico-lib-cpmm-fe/src/lib/dtos/update-task-dto.interface';
import { ExportTasksFilterState } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/export-tasks-filter.enum';
import { TaskType } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/task-type.enum';
import { WorkflowArea } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import { Annotation } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/annotation.interface';
import { TaskMetaInformation } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/task-meta-information.interface';
import { TasksFilter } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/tasks-filter.interface';
import { AnnotationsProvider } from '../../../../../../aumico-lib-cpmm-fe/src/lib/providers/annotations.provider';
import {
    selectDocuments,
    selectMandateManagementTasksByProjectId,
    selectTasksByProjectId,
    TasksOverviewState,
} from '../../../../../../aumico-lib-cpmm-fe/src/lib/reducers/tasks.reducer';
import { GetOrganizationDto, GetUserDto, OrganizationProvider } from '../../../../../../aumico-lib-users-fe/src/public-api';
import { ProjectStatus } from '@modeso/aumico-lib-projects-fe/src/lib/enums/project-status.enum';
import { BasePageComponent } from '../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'mandate-management-page',
    templateUrl: './mandate-management.page.html',
    styleUrls: ['./mandate-management.page.scss'],
})
export class MandateManagementPage extends BasePageComponent implements OnInit, OnDestroy {
    tasks$: Observable<TaskMetaInformation[]>;
    tasks: TaskMetaInformation[] = [];
    allTasks: TaskMetaInformation[] = [];
    documents$: Observable<DocumentDto[]>;
    WorkflowArea = WorkflowArea;
    TaskType = TaskType;
    assigneeOptions: INameId[] = [];
    documentsMap: { [taskId: string]: DocumentDto[] } = {};
    documentsInProgressUpload: { [taskId: string]: string[] } = {};
    activeProjectId$: Observable<string>;
    public MMconfiguratorUpdatedAt: Date | undefined;
    public lastTimeSynchronizedMM: Date | undefined;
    public projectIsInActiveState: boolean = false;
    public isSyncNeeded: boolean = false;
    public isSyncingWorkflow: boolean = false;

    private activeAnnualReport: IAnnualReport | undefined;
    private organizationName: string | undefined;
    private currentOrganization: GetOrganizationDto;
    private organizationUsers: INameId[];
    private destroy$ = new Subject<void>();
    public projectId: string;
    private tasksFilter: TasksFilter = {};
    public annotationsMap: { [key: string]: Annotation[] } = {};
    private companyName: string | undefined;
    private balanceSheetDate: string | undefined;
    openFileWindow: Window;
    // Track polling subscriptions and timeouts per file
    private pollSubs = new Map<string, Subscription>();
    private pollTimeouts = new Map<string, any>();
    private pollingDelays = [500, 500, 1000, 1500, 2500, 2500, 2500, 2500, 2500, 2500];
    documentExpirationDate: Date;

    // Varaibles for bulk edit
    bulkActions = [
        { id: 'STATUS_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_status_action_bar' },
        { id: 'ASSIGNEE_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_assignee_action_bar' },
        { id: 'DUE_DATE_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_due_date_action_bar' },
    ];
    deleteAction = { id: 'DELETE_TASKS', translationKey: 'aumico_tasks_overview_bulk_edit_delete_action_bar' };

    openBulkEditStatus: boolean = false;
    openBulkEditAssignee: boolean = false;
    openBulkEditDueDate: boolean = false;
    openBulkDeleteConfirmationDialog: boolean = false;

    possibleStatus = [
        {
            id: TaskState.OPEN,
            name: this.localizedTexts.t('aumico_pm_tasks_status_open') as string,
        },
        {
            id: TaskState.IN_PROGRESS,
            name: this.localizedTexts.t('aumico_pm_tasks_status_in_progress') as string,
        },
        {
            id: TaskState.IN_REVIEW,
            name: this.localizedTexts.t('aumico_pm_tasks_status_in_review') as string,
        },
        {
            id: TaskState.DONE,
            name: this.localizedTexts.t('aumico_pm_tasks_status_done') as string,
        },
    ];

    bulkEditStatusControl = this.fb.control(null);
    bulkEditAssigneeControl = this.fb.control(null);
    bulkEditDueDateControl = this.fb.control(null);

    // Bulk edit variables
    selectAll: Set<string> = new Set<string>();
    sectionToggled: Set<string> = new Set<string>();
    selectedTaskIds: Set<string> = new Set<string>();
    deletedUsers: GetUserDto[];

    constructor(
        private store: Store<TasksOverviewState>,
        private workflowsStore: Store<WorkflowsState>,
        private injector: Injector,
        private readonly annotationsProvider: AnnotationsProvider,
        private workflowDocumentsProvider: WorkflowDocumentsProvider,
        private readonly organizationProvider: OrganizationProvider,
        private readonly localizedTexts: I18NextService,
        private readonly actionListener$: ActionsSubject,
        private annualReportsProvider: AnnualReportProvider,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
    ) {
        super(injector);
        this.activeProjectId$ = this.store.select(selectActiveProjectId);
        this.tasks$ = this.store.select(selectMandateManagementTasksByProjectId('')); // Initial empty state
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.workflowsStore.dispatch(
            WorkflowsActions.loadWorkflows({ filter: { area: WorkflowArea.MANDATE_MANAGEMENT } }),
        );

        this.workflowsStore
            .select(selectMandateManagementWorkflow)
            .pipe(untilDestroyed(this))
            .subscribe((workflow) => {
                if (workflow) {
                    this.MMconfiguratorUpdatedAt = new Date(workflow.updatedAt);
                    this.updatedSyncNeeded();
                }
            });

        this.store
            .select(selectActiveProject)
            .pipe(untilDestroyed(this))
            .subscribe((activeProject) => {
                if (activeProject?.lastTimeSynchronizedMM) {
                    this.lastTimeSynchronizedMM = new Date(activeProject.lastTimeSynchronizedMM);
                    this.projectIsInActiveState = activeProject.projectStatus === ProjectStatus.ACTIVE;
                    this.updatedSyncNeeded();
                }
            });

        this.activeProjectId$
            .pipe(
                filter((id) => !!id),
                withLatestFrom(this.store.select(selectActiveProject)),
                filter(([id, project]) => !project),
                untilDestroyed(this),
            )
            .subscribe(([projectId]) => {
                this.store.dispatch(ProjectsOverviewActions.fetchProjectDataByProjectId({ projectId }));
            });

        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((org) => org != null),
                untilDestroyed(this),
            )
            .subscribe((org) => {
                this.currentOrganization = cloneDeep<GetOrganizationDto>(org);
                this.organizationName = org.name;
            });

        this.organizationProvider
            .getPossibleAssignees()
            .pipe(
                filter((users) => Object.keys(users).length > 0),
                map((users) =>
                    users
                        .filter((user) => user != null)
                        .map((user) => ({
                            id: user.id,
                            name: `${user.firstName} ${user.lastName}`,
                            isMe: user.isMe,
                        })),
                ),
                untilDestroyed(this),
            )
            .subscribe((users) => {
                this.organizationUsers = users;
            });

        combineLatest([this.activeProjectId$])
            .pipe(
                takeUntil(this.destroy$),
                filter(([projectId]) => !!projectId),
            )
            .subscribe(([projectId]) => {
                this.projectId = projectId;
                this.buildTasksFilter(0, 1000);
                this.store.dispatch(
                    TasksOverviewActions.loadProjectTasks({
                        projectId: this.projectId,
                        filter: this.tasksFilter,
                    }),
                );

                this.workflowsStore.dispatch(
                    WorkflowsActions.loadWorkflows({ filter: { area: WorkflowArea.MANDATE_MANAGEMENT } }),
                );

                this.tasks$ = this.store.select(selectMandateManagementTasksByProjectId(this.projectId));

                // Separately load ALL tasks (MM + CP) for tasks-export
                this.store
                    .select(selectTasksByProjectId(this.projectId))
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((allTasksFromStore) => {
                        if (allTasksFromStore && allTasksFromStore.length > 0) {
                            this.allTasks = cloneDeep(allTasksFromStore);
                        }
                    });
            });

        // Subscribe to tasks AND annotations together using combineLatest
        // This ensures annotationsMap is updated whenever EITHER tasks or annotations change
        // Using switchMap to properly switch to new task selector when projectId changes
        this.activeProjectId$
            .pipe(
                filter((projectId) => !!projectId),
                switchMap((projectId) =>
                    combineLatest([
                        this.store.select(selectMandateManagementTasksByProjectId(projectId)),
                        this.annotationsProvider.getTaskAnnotations$(),
                    ])
                ),
                takeUntil(this.destroy$),
            )
            .subscribe(([tasks, annotations]) => {
                if (tasks) {
                    this.tasks = cloneDeep(tasks);
                    // Rebuild annotationsMap for all tasks whenever tasks OR annotations change
                    tasks.forEach((task) => {
                        const taskAnnotations = annotations
                            .filter((a) => a.taskId === task.id)
                            .sort((a, b) => {
                                const dateA = new Date(a.createdAt).getTime();
                                const dateB = new Date(b.createdAt).getTime();
                                return dateB - dateA; // Latest first (descending order)
                            });
                        this.annotationsMap[task.id] = taskAnnotations;
                    });
                }
            });

        // If a taskId query param is present (e.g. from a notification click),
        // wait until tasks are loaded, then scroll to the section containing that task.
        this.activatedRoute.queryParamMap
            .pipe(
                map((queryParamMap) => queryParamMap.get('taskId')),
                filter((taskId): taskId is string => !!taskId),
                map((taskId) => {
                    this.router.navigate([], {
                        relativeTo: this.activatedRoute,
                        queryParams: { taskId: null },
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                    });
                    return taskId;
                }),
                withLatestFrom(this.activeProjectId$),
                filter(([, projectId]) => !!projectId),
                switchMap(([taskId, projectId]) =>
                    this.store.select(selectMandateManagementTasksByProjectId(projectId)).pipe(
                        filter((tasks) => tasks != null && tasks.length > 0),
                        first(),
                        map((tasks) => ({ taskId, tasks })),
                    ),
                ),
                untilDestroyed(this),
            )
            .subscribe(({ taskId, tasks }) => {
                const target = tasks.find((t) => t.id === taskId);
                if (target?.sectionName) {
                    this.store.dispatch(setScrollToTextState({ text: target.sectionName }));
                }
            });

        this.annualReportsProvider
            .getActiveAnnualReport$()
            .pipe(
                filter((report) => report != null),
                untilDestroyed(this),
            )
            .subscribe((activeReport) => {
                this.activeAnnualReport = cloneDeep(activeReport);
                this.companyName =
                    this.activeAnnualReport?.generalInformation?.company.name ||
                    this.activeAnnualReport?.setupData.company.name;
                this.balanceSheetDate =
                    this.activeAnnualReport.generalInformation?.balanceSheetDate ||
                    this.activeAnnualReport?.setupData?.balanceSheetDate;
                this.documentExpirationDate = new Date(this.balanceSheetDate);
            });

        this.actionListener$
            .pipe(ofType(DocumentsActions.exportProjectDocumentsSuccess), untilDestroyed(this))
            .subscribe(({ blob }) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const fullDate = new Date(
                    this.activeAnnualReport.generalInformation?.balanceSheetDate ||
                        this.activeAnnualReport.setupData?.balanceSheetDate,
                );

                const mm = String(fullDate.getMonth() + 1).padStart(2, '0');
                const dd = String(fullDate.getDate()).padStart(2, '0');
                const yyyy = fullDate.getFullYear();
                const date = `${dd}_${mm}_${yyyy}`;
                a.download =
                    this.activeAnnualReport != null
                        ? `${this.companyName}_${this.organizationName}_${date}.zip`
                        : `project-documents.zip`;
                a.click();
                window.URL.revokeObjectURL(url);
            });

        this.actionListener$
            .pipe(ofType(SyncActions.projectWorkflowSynced), untilDestroyed(this))
            .subscribe((action) => {
                // Fetch fresh project data after sync
                this.store.dispatch(
                    ProjectsOverviewActions.fetchProjectDataByProjectId({
                        projectId: this.projectId,
                    }),
                );
                this.isSyncingWorkflow = false;
                this.lastTimeSynchronizedMM = new Date();
                this.updatedSyncNeeded();
            });

        this.actionListener$
            .pipe(ofType(SyncActions.projectWorkflowSyncFailure), untilDestroyed(this))
            .subscribe((action) => {
                this.isSyncingWorkflow = false;
            });

        this.organizationProvider.dispatchGetUsers(true);
        // Wire up the assignee dropdown once users arrive
        this.organizationProvider
            .getUsers()
            .pipe(
                filter((users) => Object.keys(users).length > 0),
                untilDestroyed(this),
                map((users) => {
                    const deletedUsers = users.filter(user => user.isDeleted);
                    this.deletedUsers = deletedUsers;
                    const opts = users
                        .filter((user) => user != null && !user.isInvitee && !user.isDeleted)
                        .map((user) => ({
                            id: user.id,
                            name: `${user.firstName} ${user.lastName}`,
                            isMe: user.isMe,
                        }));

                    // Bring current user to top
                    const idx = opts.findIndex((o) => o.isMe === true);
                    if (idx > -1) {
                        const [me] = opts.splice(idx, 1);
                        opts.unshift(me);
                    }

                    // “Unassigned” entry
                    opts.unshift({
                        id: null,
                        name: this.localizedTexts.t('aumico_tasks_unassigned') as string,
                        isMe: false,
                    });

                    return opts;
                }),
            )
            .subscribe((opts) => {
                this.assigneeOptions = opts;
            });

        this.store
            .select(selectDocuments)
            .pipe(untilDestroyed(this))
            .subscribe((documents) => {
                documents.forEach((doc) => {
                    if (!this.documentsMap[doc.taskId]) {
                        this.documentsMap[doc.taskId] = [];
                    }
                    const taskDocs = this.documentsMap[doc.taskId];
                    // only push if we haven't already seen this doc.id
                    const exists = taskDocs.some((existing) => existing.id === doc.id);
                    if (!exists) {
                        this.documentsMap[doc.taskId].push(doc);
                    }

                    if (doc.staticTaskReference) {
                        if (!this.documentsMap[doc.staticTaskReference]) {
                            this.documentsMap[doc.staticTaskReference] = [];
                        }
                        const staticDocs = this.documentsMap[doc.staticTaskReference];
                        // only push if we haven't already seen this doc.id
                        const exists = staticDocs.some((existing) => existing.id === doc.id);
                        if (!exists) {
                            this.documentsMap[doc.staticTaskReference].push(doc);
                        }
                    }
                });
            });

        // Add this subscription to handle document metadata updates
        this.actionListener$
            .pipe(ofType(DocumentsActions.updateDocumentMetadataSuccess), untilDestroyed(this))
            .subscribe(({ document }) => {
                // Find and update the document in documentsMap
                let documentUpdated = false;

                for (const taskId in this.documentsMap) {
                    const taskDocs = this.documentsMap[taskId];
                    const docIndex = taskDocs.findIndex((d) => d.id === document?.id);

                    if (docIndex !== -1) {
                        // If we have a full document object from the action
                        if (document) {
                            // Update with the new document data
                            taskDocs[docIndex] = { ...document };
                        }
                        documentUpdated = true;
                        break;
                    }
                }

                if (documentUpdated) {
                    // Create a new reference to trigger change detection
                    this.documentsMap = { ...this.documentsMap };

                    // Force change detection
                    this.cdr.detectChanges();
                }
            });

        this.actionListener$
            .pipe(ofType(DocumentsActions.openFileSuccess), untilDestroyed(this))
            .subscribe(({ fileId, url }) => {
                this.openFileWindow = window.open(url, '_blank');
                // Revoke the URL after a delay to clean up memory
                setTimeout(() => {
                    this.workflowDocumentsProvider.dispatchRevokeFileUrl(fileId);
                }, 1000);
            });

        this.actionListener$
            .pipe(ofType(DocumentsActions.openFileFailure), untilDestroyed(this))
            .subscribe(({ error }) => {
                if (this.openFileWindow && !this.openFileWindow.closed) {
                    this.openFileWindow.close();
                    this.openFileWindow = null;
                }
            });

        // Store preview status on the document object when it's fetched
        this.actionListener$
            .pipe(ofType(DocumentsActions.checkPreviewStatusSuccess), untilDestroyed(this))
            .subscribe(({ fileId, status }) => {
                const document = this.findDocumentInMap(fileId);
                if (document) {
                    document.previewStatus = status;
                }
            });

        // Store preview URL on the document object when it's loaded
        this.actionListener$
            .pipe(ofType(DocumentsActions.loadPreviewUrlSuccess), untilDestroyed(this))
            .subscribe(({ fileId, url }) => {
                const document = this.findDocumentInMap(fileId);
                if (document) {
                    document.previewUrl = url;
                }
            });

        this.actionListener$
            .pipe(ofType(DocumentsActions.uploadDocumentSuccess), untilDestroyed(this))
            .subscribe(({ documents }) => {
                this.onDocumentsAdded(documents);
            });
    }

    addNewTask(addEvent: { createTaskDto: CreateTaskRequestDto }): void {
        this.store.dispatch(
            TasksOverviewActions.createTask({
                projectId: this.projectId,
                createTaskRequestDto: addEvent.createTaskDto,
            }),
        );
    }

    updateTask(updateEvent: { taskId: string; updateTaskDto: UpdateTaskDto }): void {
        this.store.dispatch(
            TasksOverviewActions.updateTask({ taskId: updateEvent.taskId, updateTaskDto: updateEvent.updateTaskDto }),
        );
    }

    bulkUpdateTasks(bulkUpdateEvent: { taskIds: string[]; updateTaskDto: UpdateTaskDto }): void {
        this.store.dispatch(TasksOverviewActions.bulkUpdateTasks(bulkUpdateEvent));
    }

    deleteTask(deleteEvent: { taskId: string }): void {
        this.store.dispatch(TasksOverviewActions.deleteTask({ taskId: deleteEvent.taskId }));
    }

    onAnnotationAdded(event: { taskId: string; annotation: CreateAnnotationDto }) {
        this.annotationsProvider.dispatchCreateAnnotation(event.taskId, event.annotation);
    }
    onAnnotationChanged(event: { annotationId: string; annotation: UpdateAnnotationDto }) {
        this.annotationsProvider.dispatchUpdateAnnotation(event.annotationId, event.annotation);
    }
    onAnnotationRemoved(annotationId: string) {
        this.annotationsProvider.dispatchDeleteAnnotation(annotationId);
    }

    public onDocumentRemoved(document: DocumentDto): void {
        this.workflowDocumentsProvider.dispatchDeleteDocument(document.id, this.projectId);
        // Remove from documentsMap
        Object.keys(this.documentsMap).forEach((taskId) => {
            this.documentsMap[taskId] = this.documentsMap[taskId].filter((doc) => doc.id !== document.id);
        });
    }
    public onDocumentsAdded(documents: DocumentDto[]): void {
        // Helper to strip all non-alphanumeric ASCII chars for comparison
        const stripSpecialChars = (str: string) =>
            str
                .normalize('NFD')
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLowerCase();
        for (const document of documents) {
            const originalName = stripSpecialChars(document.name); // Keep original name for comparison, normalize as the backend does

            if (!this.documentsMap[document.taskId]) {
                this.documentsMap[document.taskId] = [];
            }

            const bucket = this.documentsMap[document.taskId];

            if (!bucket.some((d) => d.id === document.id)) {
                document.name = document.name.replace(/\.[^/.]+$/, '');
                bucket.unshift(document);

                this.documentsMap = { ...this.documentsMap };
            }

            if (this.documentsInProgressUpload[document.taskId]) {
                this.documentsInProgressUpload[document.taskId] = this.documentsInProgressUpload[
                    document.taskId
                ].filter((fileName) => stripSpecialChars(fileName) !== originalName);
                this.documentsInProgressUpload = { ...this.documentsInProgressUpload };
            }
            // this.onStartPolling(document.fileId);
        }
    }

    public onDocumentsAddedInProgress(event: { taskId: string; fileNames: string[] }): void {
        if (!this.documentsInProgressUpload[event.taskId]) {
            this.documentsInProgressUpload[event.taskId] = [];
        }
        this.documentsInProgressUpload[event.taskId].push(...event.fileNames);
        this.documentsInProgressUpload = { ...this.documentsInProgressUpload };
    }

    private findDocumentInMap(fileId: string): DocumentDto | undefined {
        for (const taskId in this.documentsMap) {
            if (this.documentsMap.hasOwnProperty(taskId)) {
                const documents = this.documentsMap[taskId];
                const foundDocument = documents.find((doc) => doc.fileId === fileId);
                if (foundDocument) {
                    return foundDocument;
                }
            }
        }
        return undefined;
    }

    private buildTasksFilter(offset?: number, limit?: number): void {
        if (offset != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                offset: offset,
            };
        }

        if (limit != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                limit: limit,
            };
        }
    }

    override ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public exportZip(workFlowAreas: WorkflowArea[]): void {
        const fullDate = new Date(
            this.activeAnnualReport.generalInformation?.balanceSheetDate ||
                this.activeAnnualReport.setupData?.balanceSheetDate,
        );

        const mm = String(fullDate.getMonth() + 1).padStart(2, '0');
        const dd = String(fullDate.getDate()).padStart(2, '0');
        const yyyy = fullDate.getFullYear();
        const date = `${dd}_${mm}_${yyyy}`;
        const name =
            this.activeAnnualReport.generalInformation?.company.name || this.activeAnnualReport.setupData?.company.name;

        // Build inventory data for export
        const inventoryData = this.buildInventoryData(workFlowAreas);

        // Pass inventory data to the provider which will send it to the backend
        this.workflowDocumentsProvider.dispatchExportDocuments(
            this.projectId,
            name,
            date,
            workFlowAreas,
            inventoryData,
        );
    }

    private buildInventoryData(selectedWorkflowAreas: WorkflowArea[]): InventoryData {
        const inventoryData: InventoryData = {
            generalData: {
                companyName:
                    this.activeAnnualReport.generalInformation?.company.name ||
                    this.activeAnnualReport.setupData?.company.name ||
                    '',
                companyAdress:
                    this.activeAnnualReport.generalInformation?.company.street ||
                    this.activeAnnualReport.setupData?.company.street ||
                    '',
                companyZIP:
                    this.activeAnnualReport.generalInformation?.company.zip ||
                    this.activeAnnualReport.setupData?.company.zip ||
                    '',
                companyCity:
                    this.activeAnnualReport.generalInformation?.company.city ||
                    this.activeAnnualReport.setupData?.company.city ||
                    '',
            },
            hasCP: false,
            hasMM: false,
            MMdata: null,
            CPData: null,
        };

        // Helper to get user name from ID
        const getUserName = (userId: string | null): string => {
            if (!userId) return '';
            const user = this.organizationUsers.find((u) => u.id === userId);
            return user?.name || userId;
        };

        // Helper to map documents - returns comma-separated list of file names
        const mapDocuments = (taskId: string, staticTaskReference?: string): string => {
            const taskDocs = this.documentsMap[taskId] || [];
            const staticDocs = staticTaskReference ? this.documentsMap[staticTaskReference] || [] : [];

            // Combine both arrays and filter out duplicates by id
            const allDocs = [...taskDocs, ...staticDocs];
            const uniqueDocs = allDocs.filter((doc, index, self) => index === self.findIndex((d) => d.id === doc.id));

            return uniqueDocs.map((doc) => doc.name).join(', ');
        };

        // Initialize MM data structure
        const mmTasks: MMTask[] = [];

        // Initialize CP data structure
        const cpGeneralTasks: CPTask[] = [];
        const cpBalanceSheetTasks: CPTask[] = [];
        const cpIncomeStatementTasks: CPTask[] = [];

        // Filter and process ALL tasks (MM + CP) - include only tasks with documents
        this.allTasks.forEach((task) => {
            // Check for documents in both task.id and staticTaskReference
            const taskDocuments = this.documentsMap[task.id] || [];
            const staticDocuments = task.staticTaskReference ? this.documentsMap[task.staticTaskReference] || [] : [];
            const allTaskDocuments = [...taskDocuments, ...staticDocuments];

            // Only include tasks with documents
            if (!allTaskDocuments || allTaskDocuments.length === 0) {
                return;
            }

            // Check if this is a Mandate Management task
            if (task.area === WorkflowArea.MANDATE_MANAGEMENT) {
                // Build MMTask structure
                const mmTask: MMTask = {
                    taskSection: task.sectionName || '',
                    taskDescription: task.description || '',
                    document: mapDocuments(task.id, task.staticTaskReference),
                    assignee: getUserName(task.assignedTo),
                };
                mmTasks.push(mmTask);
            }
            // Check if this is a Closing Process task
            else if (task.area === WorkflowArea.CLOSING_PROCESS) {
                // Build CPTask structure
                const cpTask: CPTask = {
                    taskSection: task.sectionName || '',
                    taskDescription: task.description || '',
                    document: mapDocuments(task.id, task.staticTaskReference),
                };

                // Add to appropriate section based on task type
                switch (task.taskType) {
                    case TaskType.GENERAL:
                        cpGeneralTasks.push(cpTask);
                        break;
                    case TaskType.BALANCE_SHEET:
                        cpBalanceSheetTasks.push(cpTask);
                        break;
                    case TaskType.INCOME_STATEMENT:
                        cpIncomeStatementTasks.push(cpTask);
                        break;
                }
            }
        });

        // Set MMdata if there are MM tasks
        if (mmTasks.length > 0 && selectedWorkflowAreas.includes(WorkflowArea.MANDATE_MANAGEMENT)) {
            inventoryData.hasMM = true;
            inventoryData.MMdata = {
                tableHeaders: {
                    section: this.localizedTexts.t('aumico_file_export_section_title') as string,
                    descriptionTitle: this.localizedTexts.t('aumico_file_export_description_title') as string,
                    documentTitle: this.localizedTexts.t('aumico_file_export_document_title') as string,
                    assigneeTitle: this.localizedTexts.t('aumico_projects_overview_filter_assignee_label') as string,
                },
                tasks: mmTasks,
            };
        }

        // Set CPData if there are CP tasks
        if (
            (cpGeneralTasks.length > 0 || cpBalanceSheetTasks.length > 0 || cpIncomeStatementTasks.length > 0) &&
            selectedWorkflowAreas.includes(WorkflowArea.CLOSING_PROCESS)
        ) {
            inventoryData.hasCP = true;
            inventoryData.CPData = {
                tableHeaders: {
                    section: this.localizedTexts.t('aumico_file_export_section_title') as string,
                    descriptionTitle: this.localizedTexts.t('aumico_file_export_description_title') as string,
                    documentTitle: this.localizedTexts.t('aumico_file_export_document_title') as string,
                    bsTitle: this.localizedTexts.t('aumico_cp_balance_sheet') as string,
                    isTitle: this.localizedTexts.t('aumico_cp_income_statement') as string,
                    generalTitle: this.localizedTexts.t('aumico_cp_general') as string,
                },
                generalTasks: cpGeneralTasks,
                BalanceSheetTasks: cpBalanceSheetTasks,
                IncomeStatementTasks: cpIncomeStatementTasks,
            };
        }

        return inventoryData;
    }

    public exportTasksExcel(tasksFilter: (TaskState | ExportTasksFilterState)[]): void {
        const sectionDataMap = new Map<string, { name: string; tasks: ExportTasksExcelData[] }>();

        // Helper function to sanitize text for Excel export
        const sanitizeForExcel = (text: string | null | undefined): string => {
            if (!text) return '';

            return (
                text
                    // Remove or replace control characters (0x00-0x1F except tab, newline, carriage return)
                    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
                    // Replace problematic characters that can cause XML parsing issues
                    .replace(/[\uFFFE\uFFFF]/g, '')
                    // Remove backslash-escaped characters that could be problematic
                    .replace(/\\[bfnrtv]/g, '')
                    // Trim whitespace
                    .trim()
            );
        };

        this.tasks.forEach((task) => {
            const taskData = cloneDeep<TaskMetaInformation>(task);
            if (!tasksFilter.includes(task.taskState)) {
                return;
            }
            const sectionId = task['sectionId'] || task.sectionName || 'all';
            const sectionName = sanitizeForExcel(task.sectionName || sectionId);

            // Initialize the map entry if needed
            if (!sectionDataMap.has(sectionId)) {
                sectionDataMap.set(sectionId, { name: sectionName, tasks: [] });
            }

            // Get documents from both task.id and staticTaskReference
            const taskDocs = this.documentsMap[task.id] || [];
            const staticDocs = task.staticTaskReference ? this.documentsMap[task.staticTaskReference] || [] : [];

            // Combine both arrays and filter out duplicates by id
            const allDocs = [...taskDocs, ...staticDocs];
            const uniqueDocs = allDocs.filter((doc, index, self) => index === self.findIndex((d) => d.id === doc.id));

            // Sanitize document names
            const documents = uniqueDocs.map((document) => sanitizeForExcel(document.name));

            // Sanitize annotations
            const annotations =
                this.annotationsMap[task.id]?.map((annotation) => sanitizeForExcel(annotation.content)) || [];

            const isoDate = taskData.dueDate.split('T')[0];
            const [year, month, day] = isoDate.split('-');
            taskData.dueDate = `${day}.${month}.${year}`;

            switch (taskData.taskState) {
                case TaskState.OPEN:
                    taskData.taskState = this.localizedTexts.t('aumico_pm_tasks_status_open') as string;
                    break;
                case TaskState.DONE:
                    taskData.taskState = this.localizedTexts.t('aumico_pm_tasks_status_done') as string;
                    break;
                case TaskState.NOT_APPLICABLE:
                    taskData.taskState = this.localizedTexts.t('aumico_ui_not_applicable') as string;
                    break;
                case TaskState.IN_REVIEW:
                    taskData.taskState = this.localizedTexts.t('aumico_pm_tasks_status_in_review') as string;
                    break;
                case TaskState.IN_PROGRESS:
                    taskData.taskState = this.localizedTexts.t('aumico_pm_tasks_status_in_progress') as string;
                    break;
                default:
                    taskData.taskState = this.localizedTexts.t('aumico_pm_tasks_status_open') as string;
                    break;
            }

            taskData.assignedTo =
                this.organizationUsers.find((user) => {
                    return user.id === taskData.assignedTo;
                })?.name || (this.localizedTexts.t('aumico_tasks_unassigned') as string);

            // Sanitize task description and assignee name
            taskData.description = sanitizeForExcel(taskData.description);
            taskData.assignedTo = sanitizeForExcel(taskData.assignedTo);

            const row: ExportTasksExcelData = {
                task: taskData,
                documentNames: documents,
                annotations,
            };

            sectionDataMap.get(sectionId)!.tasks.push(row);
        });

        const dataToExport = Array.from(sectionDataMap.entries()).map(([id, { name, tasks }]) => ({ id, name, tasks }));

        const tableHeaders: ITasksExportTableHeaders = {
            description: this.localizedTexts.t('aumico_pm_tasks_task_table_header').toString(),
            assignedTo: this.localizedTexts.t('aumico_pm_tasks_responsible_table_header').toString(),
            dueDate: this.localizedTexts.t('aumico_pm_tasks_due_date_table_header').toString(),
            taskState: this.localizedTexts.t('aumico_pm_tasks_status_table_header').toString(),
            documents: this.localizedTexts.t('aumico_ui_documents').toString(),
            annotations: this.localizedTexts.t('aumico_ui_annotations').toString(),
            sectionName: this.localizedTexts.t('aumico_pm_tasks_section_table_header').toString(),
            companyName: this.localizedTexts.t('aumico_companies_table_label_company_name').toString(),
        };

        const fullDate = new Date(this.balanceSheetDate);
        const mm = String(fullDate.getMonth() + 1).padStart(2, '0');
        const dd = String(fullDate.getDate()).padStart(2, '0');
        const yyyy = fullDate.getFullYear();
        const date = `${dd}_${mm}_${yyyy}`;

        // Sanitize company and organization names for filename
        const sanitizedCompanyName = sanitizeForExcel(this.companyName || '');
        const sanitizedOrgName = sanitizeForExcel(this.organizationName || '');

        const fileName = `${sanitizedCompanyName}_${sanitizedOrgName}_${this.localizedTexts
            .t('aumico_reports_cpmm_tasks')
            .toString()}_${date}`;

        const tableTitle = `${sanitizedCompanyName} ${dd}.${mm}.${yyyy}`;

        this.workflowDocumentsProvider.dispatchExportTasksAsExcel(
            tableHeaders,
            dataToExport,
            fileName,
            tasksFilter,
            tableTitle,
            this.currentOrganization,
        );
    }

    updatedSyncNeeded() {
        // If lastSync is smaller than the last MMconfiguratorUpdatedAt, we need to show the sync banner
        if (this.lastTimeSynchronizedMM && this.MMconfiguratorUpdatedAt && this.projectIsInActiveState) {
            this.isSyncNeeded = this.lastTimeSynchronizedMM < this.MMconfiguratorUpdatedAt;
        } else {
            this.isSyncNeeded = false;
        }
    }
    public onDismiss(): void {
        if (this.projectId) {
            this.store.dispatch(
                SyncActions.syncProjectWorkflow({
                    projectId: this.projectId,
                    workflowArea: WorkflowArea.MANDATE_MANAGEMENT,
                    sync: false,
                }),
            );
        }
    }
    public onSync(): void {
        this.isSyncingWorkflow = true;
        if (this.projectId) {
            this.store.dispatch(
                SyncActions.syncProjectWorkflow({
                    projectId: this.projectId,
                    workflowArea: WorkflowArea.MANDATE_MANAGEMENT,
                    sync: true,
                }),
            );
        }
    }
    onOpenFile(fileId: string): void {
        this.workflowDocumentsProvider.dispatchOpenFile(fileId);
    }

    onDownloadFile(fileId: string, documentName: string): void {
        this.workflowDocumentsProvider.dispatchDownloadFile(fileId, documentName);
    }

    onStartPolling(fileId: string): void {
        console.log('onStartPolling', fileId);
        const delays = [...this.pollingDelays];
        const tick = () => {
            if (!delays.length) {
                this.onStopPolling(fileId);
                return;
            }
            const delay = delays.shift() as number;
            const timeout = setTimeout(() => {
                const sub = this.actionListener$
                    .pipe(
                        ofType(DocumentsActions.checkPreviewStatusSuccess),
                        filter((a) => a.fileId === fileId),
                        take(1),
                        untilDestroyed(this),
                    )
                    .subscribe(({ status }) => {
                        if (status === FilePreviewStatus.GENERATED) {
                            this.workflowDocumentsProvider.dispatchLoadPreviewUrl(fileId);
                            this.onStopPolling(fileId);
                        } else if (status === FilePreviewStatus.PENDING || status === FilePreviewStatus.SCANNING) {
                            tick();
                        } else if (status === FilePreviewStatus.NOT_STARTED) {
                            this.workflowDocumentsProvider.dispatchRequestPreviewGeneration(fileId);
                            tick();
                        } else {
                            this.onStopPolling(fileId);
                        }
                    });
                this.pollSubs.set(fileId, sub);
                this.workflowDocumentsProvider.dispatchCheckPreviewStatus(fileId);
            }, delay);
            this.pollTimeouts.set(fileId, timeout);
        };
        tick();
    }

    onStopPolling(fileId: string): void {
        const sub = this.pollSubs.get(fileId);
        if (sub) {
            sub.unsubscribe();
            this.pollSubs.delete(fileId);
        }
        const timeout = this.pollTimeouts.get(fileId);
        if (timeout) {
            clearTimeout(timeout);
            this.pollTimeouts.delete(fileId);
        }
    }
    // Selection logic methods
    clearAllSelections(tabs: string[]): void {
        if (tabs.includes('ALL')) {
            this.selectAll.clear();
            this.sectionToggled.clear();
            this.selectedTaskIds.clear();
            return;
        }
        tabs.forEach((tab) => {
            this.selectAll.delete(tab);
            this.selectedTaskIds.forEach((taskId) => {
                const task = this.tasks.find((t) => t.id === taskId);
                if (task && task.taskType === tab) {
                    this.selectedTaskIds.delete(taskId);
                }
            });
            this.sectionToggled.forEach((sectionId) => {
                const sectionTasks = this.tasks.filter((t) => t.sectionId === sectionId);
                if (sectionTasks.some((t) => t.taskType === tab)) {
                    this.sectionToggled.delete(sectionId);
                }
            });
        });
    }

    // Select all tasks over all sections
    toggleCheckAll(tab: string): void {
        if (this.selectAll.has(tab)) {
            this.clearAllSelections([tab]);
        } else {
            // this.sectionToggled.clear();
            // this.selectedTaskIds.clear();

            // Loop over the data and for each add task and section to the selected sets if from the correct tab
            this.tasks.forEach((task) => {
                if (task.taskType === tab) {
                    this.sectionToggled.add(task.sectionId);
                    this.selectedTaskIds.add(task.id);
                }
            });
            this.selectAll.add(tab);
        }
    }

    // Select all tasks within a specific section
    toggleSectionSelectAll(section): void {
        if (this.sectionToggled.has(section.id)) {
            // Deselect project and all its tasks
            this.sectionToggled.delete(section.id);

            // Find all tasks that are in that section, delete them.
            this.tasks.forEach((task) => {
                if (task.sectionId === section.id) {
                    this.selectedTaskIds.delete(task.id);
                }
            });
        } else {
            // Select project and all its tasks
            this.sectionToggled.add(section.id);
            // Find all tasks that are in that section, delete them.
            this.tasks.forEach((task) => {
                if (task.sectionId === section.id) {
                    this.selectedTaskIds.add(task.id);
                }
            });
        }

        // Update select all state based on current selections
        this.updateSelectAllState(section.tasks[0]?.taskType);
    }

    // Select or deselect an individual task
    toggleCheckTask(task: TaskMetaInformation): void {
        if (this.selectedTaskIds.has(task.id)) {
            // Deselect task
            this.selectedTaskIds.delete(task.id);
            this.sectionToggled.delete(task.sectionId);
        } else {
            // Select task
            this.selectedTaskIds.add(task.id);
        }

        // Update select all state based on current selections
        this.updateSelectAllState(task.taskType);
    }

    private updateSelectAllState(tab): void {
        if (this.tasks.length === 0) {
            this.selectAll.clear();
            return;
        }

        // Check if all visible tasks are selected
        let allTasksSelected = true;

        for (const task of this.tasks) {
            if (!this.selectedTaskIds.has(task.id) && task.taskType === tab) {
                allTasksSelected = false;
                break;
            }
        }
        if (allTasksSelected) {
            this.selectAll.add(tab);
        } else {
            this.selectAll.delete(tab);
        }
    }

    // Bulk actions
    onActionClicked(actionId: string): void {
        if (actionId === 'STATUS_CHANGE') {
            this.openBulkEditStatus = true;
        } else if (actionId === 'ASSIGNEE_CHANGE') {
            this.openBulkEditAssignee = true;
        } else if (actionId === 'DUE_DATE_CHANGE') {
            this.openBulkEditDueDate = true;
        } else if (actionId === 'DELETE_TASKS') {
            this.openBulkDeleteConfirmationDialog = true;
        } else if (actionId === 'CLOSE_BULK_EDIT') {
            this.clearAllSelections(['ALL']);
        }
    }

    confirmDeleteBulkTasks(): void {
        this.openBulkDeleteConfirmationDialog = false;
        this.store.dispatch(TasksOverviewActions.bulkDeleteTasks({ taskIds: Array.from(this.selectedTaskIds) }));
        this.clearAllSelections(['ALL']);
    }

    cancelDeleteBulkTasks(): void {
        // No action needed, just close the dialog
        this.openBulkDeleteConfirmationDialog = false;
    }

    onEditStatusConfirm(): void {
        if (this.bulkEditStatusControl.value) {
            this.openBulkEditStatus = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTaskIds),
                    updateTaskDto: {
                        taskState: this.bulkEditStatusControl.value.id,
                    },
                }),
            );
            this.bulkEditStatusControl.reset();
            this.clearAllSelections(['ALL']);
        }
    }

    onEditAssigneeConfirm(): void {
        if (this.bulkEditAssigneeControl.value) {
            this.openBulkEditAssignee = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTaskIds),
                    updateTaskDto: {
                        assignedTo: this.bulkEditAssigneeControl.value.id,
                    },
                }),
            );
            this.bulkEditAssigneeControl.reset();
            this.clearAllSelections(['ALL']);
        }
    }

    onEditDueDateConfirm(): void {
        if (this.bulkEditDueDateControl.value) {
            this.openBulkEditDueDate = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTaskIds),
                    updateTaskDto: {
                        dueDate: this.bulkEditDueDateControl.value,
                    },
                }),
            );
            this.bulkEditDueDateControl.reset();
            this.clearAllSelections(['ALL']);
        }
    }

    public bulkEditDueDate(m: Moment): void {
        // Build UTC midnight for that calendar day
        const year = m.year();
        const month = m.month(); // 0-based
        const dday = m.date();

        const asUtc = new Date(Date.UTC(year, month, dday, 0, 0, 0, 0));
        this.bulkEditDueDateControl.setValue(asUtc);
    }
}
